import { render, staticRenderFns } from "./GiftDetail.vue?vue&type=template&id=8ab25b94&scoped=true&lang=pug&"
import script from "./GiftDetail.vue?vue&type=script&lang=ts&"
export * from "./GiftDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GiftDetail.vue?vue&type=style&index=0&id=8ab25b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab25b94",
  null
  
)

export default component.exports